import type { DriverDayOffType } from '@/backend/market'

export class ReviewDriverDayOffEntity {
  startDate?: Date | string | null
  endDate?: Date | string | null
  type?: DriverDayOffType
  reviewNotes?: string | null
}
